module.exports = __webpack_public_path__ + "static/media/modifyMobile.9797a8b2.svg";